import { render, staticRenderFns } from "./AddRemark.vue?vue&type=template&id=e111550c&scoped=true"
import script from "./AddRemark.vue?vue&type=script&lang=ts"
export * from "./AddRemark.vue?vue&type=script&lang=ts"
import style0 from "./AddRemark.vue?vue&type=style&index=0&id=e111550c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e111550c",
  null
  
)

export default component.exports